module.exports = __webpack_public_path__ + "static/media/play.95b9e9af.svg";